import React from 'react'
import { Bat } from './components/bat'
import './styles.scss'

const Bats = () => {
  return (
    <div className="bats absolute">
      {[1, 2, 3, 4, 5, 6].map(key => (
        <Bat batNumber={key} key={key} />
      ))}
    </div>
  )
}

export default Bats
